'use strict';

import {
  apiUrl
} from '../../app.api.config';

export default class PersonService {
  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  };
  update = function (request) {
    return this.$http.put(apiUrl().API_URL + '/admin/persons?XDEBUG_SESSION_START=PHPSTORM', request);
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/model/Person.js